<template lang="html">
  <div class="notifications-wrapper">
    <div class="table-wrapper">
      <div v-if="notifications.length">
        <div
          v-for="notification in notifications"
          :key="notification.msg_id"
          class="notification"
          @click="
            seeNotification(notification);
            notification.open = !notification.open;
            notification.msg_read = 1;
          "
        >
          <div class="notification-info">
            <div class="left">
              <div class="dot" v-if="notification.msg_read != 1"></div>
              <div
                v-html="generateMessage(notification.msg_message)"
                class="ntf-text clip-text"
              ></div>
            </div>
            <div class="right">
              <div class="ntf-date">
                {{ $moment(notification.msg_date).format("DD.MM.YYYY HH:mm") }}
              </div>
              <Icon
                class="icon"
                icon="mdi:chevron-down"
                :class="{ rotate: notification.open }"
              ></Icon>
              <span
                @click.stop="deleteNotification(notification.msg_id, $event)"
              >
                <Icon class="icon red" icon="mdi:close"></Icon>
              </span>
            </div>
          </div>
          <div
            class="notification-text"
            :style="{ maxHeight: notification.open ? '3000px' : '0' }"
          >
            <single-notification :notification="notification.msg_id" />
          </div>
        </div>
      </div>
      <div v-else class="no-data">
        {{ $t("profile.notifications.noNotifications") }}
      </div>
      <div v-if="notifications.length > 0" class="pagination-wrapper">
        <paginate
          v-model="page"
          :page-count="pageCount"
          :prev-text="getPaginationImages('Left')"
          :next-text="getPaginationImages('Right')"
          :container-class="'pagination'"
          :page-class="'page'"
          :click-handler="changePage"
        >
        </paginate>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from "@/shared/eventBus.js";
import Paginate from "vuejs-paginate";
import { api } from "@/api";
import SingleNotification from "@/components/profile/notification.vue";
import { Icon } from "@iconify/vue2";
export default {
  name: "notifications",
  components: {
    SingleNotification,
    Paginate,
    Icon
  },
  data() {
    return {
      notifications: [],
      activeNotification: null,
      page: 1,
      pageCount: 0
    };
  },
  mounted() {
    this.getNotifications();
    eventBus.$on("refreshNotifications", () => {
      this.getNotifications();
    });
  },
  activated() {
    this.getNotifications();
  },
  methods: {
    deleteNotification(id) {
      let modalData = {
        title: this.$t("modal.deleteNotifi"),
        ok: () => {
          api
            .deleteNotification(id)
            .then(() => {
              this.getNotifications();
            })
            .catch(e => {
              console.log(e);
            });
        }
      };
      let params = {
        modalData: modalData,
        component: "confirmModal"
      };
      eventBus.$emit("openModal", params);
    },
    async seeNotification(notification) {
      let params = {
        id: notification.msg_id
      };
      await api.seenUserNotification(params).catch(e => {
        console.log(e);
      });
      await api.getNotificationsCount().then(res => {
        this.$store.commit("setNotificationCounters", res.data);
      });
    },
    getNotifications() {
      let params = {
        page: this.page
      };
      api
        .getNotifications(params)
        .then(res => {
          for (var i = 0; i < res.data.data.length; i++) {
            res.data.data[i].open = false;
          }
          this.notifications = res.data.data;
          this.pageCount = res.data.page_count;
        })
        .catch(e => {
          console.log(e);
        });
    },
    getPaginationImages(side) {
      let path = require(`@/assets/icons/pagination${side}.png`);
      return `<img src='${path}' alt='pagination left image'>`;
    },
    changePage(page) {
      this.page = page;
    },
    getDate(date) {
      return this.$moment(date).format("DD.MM.YYYY HH:mm");
    }
  },
  computed: {
    generateMessage() {
      return notification => {
        if (notification.type === "new") {
          return this.$t("profile.notifications.new", {
            name: notification.pro_name,
            link:
              window.location.origin +
              "/" +
              this.$route.params.lang +
              "/details/" +
              notification.pro_id,
            buyerUsername: notification.buyer_username,
            quantity: notification.off_quantity,
            price: notification.price,
            currency: notification.cur_id
          });
        }
        if (notification.type === "new-buyer") {
          return this.$t("profile.notifications.new-buyer", {
            name: notification.pro_name,
            id: notification.off_id,
            quantity: notification.off_quantity,
            price: notification.price,
            currency: notification.cur_id,
            link:
              window.location.origin +
              "/" +
              this.$route.params.lang +
              "/details/" +
              notification.pro_id
          });
        }
        if (notification.type === "sold-out") {
          return this.$t("profile.notifications.sold-out", {
            name: notification.pro_name
          });
        }
        if (notification.type === "reject-buyer") {
          return this.$t("profile.notifications.reject-buyer", {
            username: notification.seller_username,
            name: notification.pro_name
          });
        }
        if (notification.type === "reject-seller") {
          return this.$t("profile.notifications.reject-seller", {
            username: notification.buyer_username,
            name: notification.pro_name
          });
        }
        if (notification.type === "rating") {
          return this.$t("profile.notifications.rating", {
            comment: notification.comment,
            rating: notification.rating,
            username: notification.usr_username,
            name: notification.pro_name
          });
        }
        if (notification.type === "near-exp-seller") {
          return this.$t("profile.notifications.near-exp-seller", {
            date: this.getDate(notification.pro_expiry),
            name: notification.pro_name,
            link:
              window.location.origin +
              "/" +
              this.$route.params.lang +
              "/details/" +
              notification.pro_id,
            rules:
              window.location.origin + "/" + this.$route.params.lang + "/rules"
          });
        }
        if (notification.type === "near-exp-buyer") {
          return this.$t("profile.notifications.near-exp-buyer", {
            date: this.getDate(notification.pro_expiry),
            name: notification.pro_name,
            link:
              window.location.origin +
              "/" +
              this.$route.params.lang +
              "/details/" +
              notification.pro_id
          });
        }
        if (notification.type === "expired-seller-sold-out") {
          return this.$t("profile.notifications.expired-seller-sold-out", {
            name: notification.pro_name,
            link:
              window.location.origin +
              "/" +
              this.$route.params.lang +
              "/details/" +
              notification.pro_id
          });
        }
        if (notification.type === "expired-seller-price") {
          return this.$t("profile.notifications.expired-seller-price", {
            name: notification.pro_name,
            link:
              window.location.origin +
              "/" +
              this.$route.params.lang +
              "/details/" +
              notification.pro_id,
            offCount: notification.off_count
          });
        }
        if (notification.type === "expired-seller-no-buyers") {
          return this.$t("profile.notifications.expired-seller-no-buyers", {
            name: notification.pro_name,
            link:
              window.location.origin +
              "/" +
              this.$route.params.lang +
              "/details/" +
              notification.pro_id
          });
        }
        if (notification.type === "expired-buyer-sold-out") {
          return this.$t("profile.notifications.expired-buyer-sold-out", {
            name: notification.pro_name,
            link:
              window.location.origin +
              "/" +
              this.$route.params.lang +
              "/details/" +
              notification.pro_id,
            price: notification.price,
            date: this.getDate(notification.pro_expiry),
            currency: notification.cur_id
          });
        }
        if (notification.type === "expired-buyer-price") {
          return this.$t("profile.notifications.expired-buyer-price", {
            name: notification.pro_name,
            link:
              window.location.origin +
              "/" +
              this.$route.params.lang +
              "/details/" +
              notification.pro_id,
            price: notification.price,
            date: this.getDate(notification.pro_expiry),
            currency: notification.cur_id,
            mun_unit: notification.mun_unit
          });
        }
        if (notification.type === "expired-buyer-unsold") {
          return this.$t("profile.notifications.expired-buyer-unsold", {
            name: notification.pro_name,
            link:
              window.location.origin +
              "/" +
              this.$route.params.lang +
              "/details/" +
              notification.pro_id
          });
        }
        if (notification.type === "seller-gave-up") {
          return this.$t("profile.notifications.seller-gave-up", {
            username: notification.seller_username,
            name: notification.pro_name
          });
        }
        if (notification.type === "new-product-admin") {
          return this.$t("profile.notifications.new-product-admin", {
            username: notification.usr_username,
            name: notification.pro_name,
            link:
              window.location.origin +
              "/" +
              this.$route.params.lang +
              "/details/" +
              notification.pro_id
          });
        }
        if (notification.type === "three-day-seller") {
          return this.$t("profile.notifications.three-day-seller", {
            username: localStorage.getItem("userName"),
            name: notification.pro_name,
            date: this.getDate(notification.pro_expiry),
            link:
              window.location.origin +
              "/" +
              this.$route.params.lang +
              "/details/" +
              notification.pro_id
          });
        }
        if (notification.type === "renew-product") {
          return this.$t("profile.notifications.renew-product", {
            username: notification.usr_username,
            name: notification.pro_name,
            link:
              window.location.origin +
              "/" +
              this.$route.params.lang +
              "/details/" +
              notification.pro_id
          });
        }
        if (notification.type === "admin-deleted") {
          return this.$t("profile.notifications.admin-deleted", {
            name: notification.pro_name
          });
        }
        if (notification.type === "admin-rating") {
          return this.$t("profile.notifications.admin-rating", {
            comment: notification.comment,
            rating: notification.rating,
            usernameFrom: notification.usr_username_from,
            usernameTo: notification.usr_username_to
          });
        }
        if (notification.type === "removed-product-admin") {
          return this.$t("profile.notifications.removed-product-admin", {
            name: notification.pro_name,
            link:
              window.location.origin +
              "/" +
              this.$route.params.lang +
              "/details/" +
              notification.pro_id,
            username: notification.usr_username
          });
        }
        if (notification.type === "offer-edit") {
          return this.$t("profile.notifications.offer-edit", {
            name: notification.pro_name,
            link:
              window.location.origin +
              "/" +
              this.$route.params.lang +
              "/details/" +
              notification.pro_id,
            buyerUsername: notification.buyer_username,
            quantity: notification.off_quantity,
            price: notification.price
          });
        }
        if (
          notification.type === "three-day-admin" ||
          notification.type === "near-exp-admin"
        ) {
          return this.$t("profile.notifications.three-day-admin", {
            name: notification.pro_name,
            link:
              window.location.origin +
              "/" +
              this.$route.params.lang +
              "/details/" +
              notification.pro_id,
            date: this.getDate(notification.pro_expiry)
          });
        }
        if (notification.type === "expired-admin-price") {
          return this.$t("profile.notifications.expired-admin-price", {
            name: notification.pro_name,
            link:
              window.location.origin +
              "/" +
              this.$route.params.lang +
              "/details/" +
              notification.pro_id,
            offCount: notification.off_count
          });
        }
        if (notification.type === "expired-admin-no-buyers") {
          return this.$t("profile.notifications.expired-admin-no-buyers", {
            name: notification.pro_name,
            link:
              window.location.origin +
              "/" +
              this.$route.params.lang +
              "/details/" +
              notification.pro_id
          });
        }
        if (notification.type === "expired-admin-sold-out") {
          return this.$t("profile.notifications.expired-admin-sold-out", {
            name: notification.pro_name,
            link:
              window.location.origin +
              "/" +
              this.$route.params.lang +
              "/details/" +
              notification.pro_id
          });
        }
        if (notification.type === "new-user-admin") {
          return this.$t("profile.notifications.new-user-admin", {
            cnt_name: notification.cnt_name,
            org_contact: notification.org_contact,
            org_id: notification.org_id,
            org_pib: notification.org_pib,
            osr_name: notification.osr_name,
            otp_name: notification.otp_name,
            type: notification.type,
            usr_address: notification.usr_address,
            usr_email: notification.usr_email,
            usr_name: notification.usr_name,
            usr_phone_number: notification.usr_phone_number,
            usr_postal_code: notification.usr_postal_code,
            usr_region: notification.usr_region,
            usr_username: notification.usr_username
          });
        }
        if (notification.type === "seller-changed") {
          return this.$t("profile.notifications.seller-changed", {
            newUsername: notification.new_usr_username,
            newAddress: notification.new_usr_address,
            newCountry: notification.new_cnt_name,
            newPhone: notification.new_usr_phone_number,
            newRegion: notification.new_usr_region,
            newPostal: notification.new_usr_postal_code,
            oldUsername: notification.old_usr_username,
            oldAddress: notification.old_usr_address,
            oldCountry: notification.old_cnt_name,
            oldPhone: notification.old_usr_phone_number,
            oldRegion: notification.old_usr_region,
            oldPostal: notification.old_usr_postal_code
          });
        }
        if (notification.type === "buyer-changed") {
          return this.$t("profile.notifications.buyer-changed", {
            newUsername: notification.new_usr_username,
            newAddress: notification.new_usr_address,
            newCountry: notification.new_cnt_name,
            newPhone: notification.new_usr_phone_number,
            newRegion: notification.new_usr_region,
            newPostal: notification.new_usr_postal_code,
            oldUsername: notification.old_usr_username,
            oldAddress: notification.old_usr_address,
            oldCountry: notification.old_cnt_name,
            oldPhone: notification.old_usr_phone_number,
            oldRegion: notification.old_usr_region,
            oldPostal: notification.old_usr_postal_code
          });
        }
        return notification.type;
      };
    }
  },
  watch: {
    page: {
      handler() {
        this.getNotifications();
      }
    }
  },
  destroyed() {
    eventBus.$off("refreshNotifications");
  },
  deactivated() {
    eventBus.$off("refreshNotifications");
  }
};
</script>

<style lang="scss" scoped>
.notifications-wrapper {
  // max-width: 800px;
  .notification {
    box-sizing: border-box;
    width: 100%;
    background: $gray-blue-400;
    border: 1px solid $gray-blue-700;
    border-radius: 15px;
    margin: 10px 0;
    padding: 5px 20px;

    .notification-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      .left {
        width: 60%;
        display: flex;
        align-items: center;
        .dot {
          min-height: 10px;
          min-width: 10px;
          background-color: $light-blue-600;
          border-radius: 50%;
          display: inline-block;
          margin-right: 10px;
        }
        .ntf-text {
          max-height: 60px;
          overflow: hidden;
          line-height: 60px;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 100%;
          text-align: left;
        }
      }
      .right {
        width: 40%;
        text-align: right;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 5px;
        .ntf-date {
          color: $blue-400;
        }
        .icon {
          font-size: 30px;
          cursor: pointer;
          &.rotate {
            transition: transform 0.2s;
            transform: rotate(180deg);
          }
          &.red {
            color: $red-600;
            margin-left: 10px;
          }
        }
      }
    }
    .notification-text {
      transition: max-height 0.6s ease;
      overflow: hidden;
    }
  }
}
</style>
